import { BaseRepository } from "repositories/BaseRepository";

export class LinesRepository extends BaseRepository {
  constructor(db) {
    super(db, "lines");
  }
}
